import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  { body: ["Welcome to inonit.", "inonit is a social discovery platform that helps people create, discover, and join local events and experiences.", "By accessing or using inonit, you agree to these Terms & Conditions. If you do not agree, please do not use the platform."] },
  { heading: "1. Eligibility", body: [
    "You must be at least 16 years old to use inonit.",
    "By using the platform, you confirm that:",
    ["the information you provide is accurate", "you are legally allowed to use the service", "you will comply with these terms and all applicable laws"],
  ] },
  { heading: "2. User Accounts", body: [
    "You are responsible for:",
    ["maintaining the security of your account", "keeping your login credentials confidential", "all activity that occurs under your account"],
    "We may suspend or terminate accounts that:",
    ["violate these terms", "engage in harmful or illegal activity", "impersonate others", "misuse the platform"],
  ] },
  { heading: "3. Events & Content", body: [
    "Users are responsible for the events and content they create.",
    "You agree not to post:",
    ["illegal content", "harassment or hate speech", "explicit or violent material", "spam or misleading information", "fraudulent events", "copyrighted content without permission"],
    "inonit may remove events or content that violate these rules without notice.",
  ] },
  { heading: "4. Safety", body: [
    "inonit does not conduct background checks on users and is not responsible for user behavior during events or interactions.",
    "Always use personal judgment and prioritize your safety when attending events or meeting others.",
  ] },
  { heading: "5. Event Participation", body: [
    "When joining an event:",
    ["attendance is at your own risk", "organizers are responsible for their own events", "inonit is not liable for cancellations, disputes, injuries, losses, or damages related to events"],
  ] },
  { heading: "6. Platform Availability", body: [
    "We may modify, suspend, or discontinue parts of the platform at any time without notice.",
    "We do not guarantee uninterrupted or error-free service.",
  ] },
  { heading: "7. Intellectual Property", body: [
    "All branding, design elements, logos, and platform content related to inonit remain the property of inonit unless otherwise stated.",
    "Users retain ownership of the content they upload but grant inonit permission to display and distribute that content within the platform.",
  ] },
  { heading: "8. Termination", body: [
    "You may delete your account at any time.",
    "We reserve the right to suspend or terminate accounts that violate these terms or harm the platform/community.",
  ] },
  { heading: "9. Limitation of Liability", body: [
    "To the maximum extent permitted by law, inonit is not liable for:",
    ["indirect damages", "lost profits", "personal injury", "disputes between users", "damages arising from platform use or event participation"],
  ] },
  { heading: "10. Changes to Terms", body: [
    "We may update these Terms & Conditions periodically.",
    "Continued use of the platform after updates means you accept the revised terms.",
  ] },
  { heading: "11. Contact", body: [
    "For questions regarding these Terms & Conditions, contact:",
    "mailto:founder@inonit.app",
  ] },
];

export default function TermsPage() {
  return <LegalPage title="Terms & Conditions" lastUpdated="Last updated · May 2026" sections={SECTIONS} />;
}
